import type { LegacyRef, ReactNode, RefObject } from 'react'
import { forwardRef } from 'react'

import { Line } from 'react-chartjs-2'

import type { ChartData, ChartOptions, Chart } from 'chart.js'

import '@web/entities/chart/lib/chart-js.setup'

interface TProps {
  data: ChartData<'line'>
  options: ChartOptions<'line'>
  width?: string | number
  height?: string | number
  containerRef?: LegacyRef<HTMLDivElement>
  children?: ReactNode
}

export const ResponsiveChart = forwardRef<Chart<'line'>, TProps>(
  function ResponsiveChart(
    { data, height = '450px', width = '100%', options, containerRef, children },
    ref
  ) {
    return (
      <div
        ref={containerRef}
        style={{
          position: 'relative',
          width: width,
          height: height,
          minHeight: 0
        }}
      >
        {children}
        <Line
          ref={ref as RefObject<Chart<'line'>>}
          data={data}
          options={{
            ...options,
            responsive: true,
            maintainAspectRatio: false,
            animation: false
          }}
        />
      </div>
    )
  }
)
